import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Campaigns from './pages/Campaigns';
import Recommendations from './pages/Recommendations';
import Scenarios from './pages/Scenarios';
import Creative from './pages/Creative';
import Chat from './pages/Chat';
import Admin from './pages/Admin';
import CompetitiveIntelligence from './pages/CompetitiveIntelligence';
import Integrations from './pages/Integrations';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import PendingApproval from './pages/PendingApproval';
import About from './pages/About';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import './App.css';

function AppContent() {
  const location = useLocation();
  
  // CRITICAL: Check for session_id synchronously during render (before useEffect)
  // This prevents race conditions with ProtectedRoute
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/pending-approval" element={<PendingApproval />} />
      
      {/* Protected Routes */}
      <Route path="/" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
      <Route path="/campaigns" element={<ProtectedRoute><Layout><Campaigns /></Layout></ProtectedRoute>} />
      <Route path="/recommendations" element={<ProtectedRoute><Layout><Recommendations /></Layout></ProtectedRoute>} />
      <Route path="/scenarios" element={<ProtectedRoute><Layout><Scenarios /></Layout></ProtectedRoute>} />
      <Route path="/competitive" element={<ProtectedRoute><Layout><CompetitiveIntelligence /></Layout></ProtectedRoute>} />
      <Route path="/creative" element={<ProtectedRoute><Layout><Creative /></Layout></ProtectedRoute>} />
      <Route path="/chat" element={<ProtectedRoute><Layout><Chat /></Layout></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><Layout><Admin /></Layout></ProtectedRoute>} />
      <Route path="/integrations" element={<ProtectedRoute><Layout><Integrations /></Layout></ProtectedRoute>} />
      <Route path="/about" element={<Layout><About /></Layout>} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
